import './index.css'
import '@/shared/i18n'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createApp } from '@/app/create-app'

const { App } = createApp()

const root = document.getElementById('root')
if (!root) throw new Error('Elemento #root não encontrado.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
